import { AxiosRequestConfig } from 'axios'
import { IResponseBase, Repository } from 'ecp/repositories/Repository'

import api from 'services/api'

class DownloadModelsRepository extends Repository {
  showNotaryFeesModel (config?: AxiosRequestConfig): Promise<IResponseBase> {
    return Repository.handle(() =>
      this.api.get(`${this.path}/notary-fees/`, config)
    )
  }

  uploadNotaryFeesModel (file: FormData, config?: AxiosRequestConfig): Promise<IResponseBase> {
    return Repository.handle(() =>
      this.api.post(`${this.path}/notary-fees`, file, config)
    )
  }

  showOutstandingBalanceModel (config?: AxiosRequestConfig): Promise<IResponseBase> {
    return Repository.handle(() =>
      this.api.get(`${this.path}/outstanding-balance/`, config)
    )
  }

  uploadOutstandingBalanceModel (file: FormData, config?: AxiosRequestConfig): Promise<IResponseBase> {
    return Repository.handle(() =>
      this.api.post(`${this.path}/outstanding-balance/`, file, config)
    )
  }
}

export const downloadModelRepository = new DownloadModelsRepository({ api, path: '/download-models' })

class PricingRepository extends Repository {
  uploadNotaryFees (file: FormData, config?: AxiosRequestConfig): Promise<IResponseBase> {
    return Repository.handle(() =>
      this.api.post(`${this.path}/notary-fees/upload`, file, config)
    )
  }

  getNotaryFeesFileStatus (id: string, config?: AxiosRequestConfig): Promise<IResponseBase> {
    return Repository.handle(() =>
      this.api.get(`${this.path}/notary-fees/status/${id}`, config)
    )
  }

  getLastNotaryFees (config?: AxiosRequestConfig): Promise<IResponseBase> {
    return Repository.handle(() =>
      this.api.get(`${this.path}/notary-fees/last `, config)
    )
  }

  uploadOutstandingBalance (file: FormData, config?: AxiosRequestConfig): Promise<IResponseBase> {
    return Repository.handle(() =>
      this.api.post(`${this.path}/outstanding-balance/upload`, file, config)
    )
  }

  getOutstandingBalanceFileStatus (id: string, config?: AxiosRequestConfig): Promise<IResponseBase> {
    return Repository.handle(() =>
      this.api.get(`${this.path}/outstanding-balance/status/${id}`, config)
    )
  }

  downloadOutstandingBalanceFile (id: string, config?: AxiosRequestConfig): Promise<Blob> {
    return this.api.get(`${this.path}/outstanding-balance/download/${id}`, {
      ...config,
      responseType: 'blob'
    }).then(response => response.data)
  }
}

export const pricingRepository = new PricingRepository({ api, path: '/pricings' })
